import { useState } from "react";
import moment from "moment";

import { setForm } from "../../services/form";

import { getFormData, setSeason as setLocalStorageSeason, getSystemSettings, getSeason } from "../../utils/SettingsRetriever";
import PushHistory from '../../utils/PushHistory';

const useLogic = (props) => {
    const [season, setSeason] = useState(getSeason());
    const { seasonality, mobile } = props;

    const updateSeason = (e, season) => {
        const system = getSystemSettings();
        let newSeason = seasonality.list.find(s => s.name === season);
        let currentSeason = season;
    
        if (currentSeason && currentSeason.name !== newSeason.name){
            let currentForm = getFormData();
            let arrivalDate = moment.utc(newSeason.start).startOf("day");
            let departureDate = moment.utc(newSeason.end).startOf("day");
            if (arrivalDate.isBefore(moment.utc().startOf("day"))){
                arrivalDate = moment.utc().add(2, "days");
                departureDate = moment.utc().add(4, "days");
            }
            Object.keys(currentForm).forEach(sectionForm => {
                if (currentForm[sectionForm].startDate !== undefined){
                    currentForm[sectionForm].startDate = arrivalDate.format("YYYY-MM-DD")
                }
                if (currentForm[sectionForm].arrivalDate !== undefined){
                    currentForm[sectionForm].arrivalDate = arrivalDate.format("YYYY-MM-DD")
                }
                if (currentForm[sectionForm].departureDate !== undefined){
                    currentForm[sectionForm].departureDate = departureDate.format("YYYY-MM-DD")
                }
                if (sectionForm === "liftTickets"){
                    currentForm[sectionForm].month = arrivalDate.format("M");
                    currentForm[sectionForm].year = arrivalDate.format("YYYY");
                }
                currentForm[sectionForm].manualSearch = true;
            })
            setSeason(newSeason)
            setForm(currentForm, false)
            setLocalStorageSeason(newSeason);
            let currentCategory = system.categories.find(cat => cat.href.indexOf(window.location.pathname) >= 0)
            if (currentCategory && currentCategory.config && currentCategory.config.seasons && currentCategory.config.seasons.indexOf(newSeason.name) >= 0){
                window.location.reload();
            } else if (newSeason.defaultCategory){
                let newCategory = system.categories.find(cat => cat.code === newSeason.defaultCategory);
                if (newCategory && newCategory.href){
                    if (Array.isArray(newCategory.href)){
                        PushHistory(newCategory.href[0])
                    } else {
                        PushHistory(newCategory.href)
                    }
                }
            } else {
                PushHistory("/")
            }
        }
    }

    const checkForSmallerSeasonality = () => {
        return !mobile && getSystemSettings().head && getSystemSettings().head.topbarConfiguration && getSystemSettings().head.topbarConfiguration.smallerSeasonality ? true : false
    }

    return {
        season,
        updateSeason,
        checkForSmallerSeasonality,
        seasonality
      };

}


export default useLogic;